import posthog from 'posthog-js'

posthog.init('phc_BV3TNdk0zHpKElNC6FC9FiLqRsBNVTFnMhGrMtJm2xm', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2025-11-30'
})
